import { Coverage, CoverageLevel, ScreenWithCoverages } from "../types";
import { PackageCoverageAccessor } from "./packageCoverageAccessor";
import { getPackageCoverageGetters } from "./packageCoveragesDetails";

const getPackageCoveragesMap = (
  screen: ScreenWithCoverages
): Record<PackageCoverageAccessor, Coverage> => ({
  [PackageCoverageAccessor.HomeCoverage]: {
    accessor: PackageCoverageAccessor.HomeCoverage,
    image: "/images/plan-icons/details/homeCoverage.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(PackageCoverageAccessor.HomeCoverage, screen),
  },
  [PackageCoverageAccessor.HomeCoverageSettlementType]: {
    accessor: PackageCoverageAccessor.HomeCoverageSettlementType,
    image: "/images/plan-icons/details/homeCoverage.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.HomeCoverageSettlementType,
      screen
    ),
  },
  [PackageCoverageAccessor.YourBelongings]: {
    accessor: PackageCoverageAccessor.YourBelongings,
    image: "/images/plan-icons/details/belongings.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.YourBelongings,
      screen
    ),
  },
  [PackageCoverageAccessor.YourBelongingsSettlementType]: {
    accessor: PackageCoverageAccessor.YourBelongingsSettlementType,
    image: "/images/plan-icons/details/belongings.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.YourBelongingsSettlementType,
      screen
    ),
  },
  [PackageCoverageAccessor.OtherStructures]: {
    accessor: PackageCoverageAccessor.OtherStructures,
    image: "/images/plan-icons/details/otherStructures.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.OtherStructures,
      screen
    ),
  },
  [PackageCoverageAccessor.OtherStructuresSettlementType]: {
    accessor: PackageCoverageAccessor.OtherStructuresSettlementType,
    image: "/images/plan-icons/details/otherStructures.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.OtherStructuresSettlementType,
      screen
    ),
  },
  [PackageCoverageAccessor.StandardDeductible]: {
    accessor: PackageCoverageAccessor.StandardDeductible,
    image: "/images/plan-icons/details/standardDeductible.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.StandardDeductible,
      screen
    ),
  },
  [PackageCoverageAccessor.WindHail]: {
    accessor: PackageCoverageAccessor.WindHail,
    image: "/images/plan-icons/details/windHail.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(PackageCoverageAccessor.WindHail, screen),
  },
  [PackageCoverageAccessor.WaterDamageDeductible]: {
    accessor: PackageCoverageAccessor.WaterDamageDeductible,
    image: "/images/plan-icons/water.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.WaterDamageDeductible,
      screen
    ),
  },
  [PackageCoverageAccessor.LossOfUse]: {
    accessor: PackageCoverageAccessor.LossOfUse,
    image: "/images/plan-icons/details/additionalLivingExpenses.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(PackageCoverageAccessor.LossOfUse, screen),
  },
  [PackageCoverageAccessor.WaterDamage]: {
    accessor: PackageCoverageAccessor.WaterDamage,
    image: "/images/plan-icons/water.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(PackageCoverageAccessor.WaterDamage, screen),
  },
  [PackageCoverageAccessor.MedicalPayments]: {
    accessor: PackageCoverageAccessor.MedicalPayments,
    image: "/images/plan-icons/details/medicalPayments.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.MedicalPayments,
      screen
    ),
  },
  [PackageCoverageAccessor.PersonalLiability]: {
    accessor: PackageCoverageAccessor.PersonalLiability,
    image: "/images/plan-icons/details/personalLiability.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.PersonalLiability,
      screen
    ),
  },
  [PackageCoverageAccessor.PremisesLiability]: {
    accessor: PackageCoverageAccessor.PremisesLiability,
    image: "/images/plan-icons/details/personalLiability.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.PremisesLiability,
      screen
    ),
  },
  [PackageCoverageAccessor.InflationGuard]: {
    accessor: PackageCoverageAccessor.InflationGuard,
    image: "/images/plan-icons/details/inflation-guard-coverage.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.InflationGuard,
      screen
    ),
  },
  [PackageCoverageAccessor.RoofPaymentSchedule]: {
    accessor: PackageCoverageAccessor.RoofPaymentSchedule,
    image: "/images/plan-icons/details/roof-payment-schedule-coverage.webp",
    level: CoverageLevel.Unit,
    ...getPackageCoverageGetters(
      PackageCoverageAccessor.RoofPaymentSchedule,
      screen
    ),
  },
});

export { getPackageCoveragesMap };
